import { useMutation } from '@tanstack/react-query';

import { APIClient } from ':cloud/state/Api';

const errorMsg = 'An error occurred updating customer limits. Please retry';
async function upgradeLimits(id: string, version: string): Promise<null> {
  const path = `/v1/resources/upgrade`;
  const { data } = await APIClient.post<null>(path, { resourceId: id, version });
  return data;
}

export function useUpgradeLimits(resourceId: string) {
  return useMutation({
    mutationFn: async (version: string) => upgradeLimits(resourceId, version),
    onError: (error) => {
      // eslint-disable-next-line no-console
      console.log(error);
    },
    meta: { errorMsg },
  });
}
